export default __webpack_public_path__ + "static/media/CK.af7bee35.svg";